import { useEffect, useState } from 'react';
import { TextInput, StyleSheet, Pressable } from 'react-native';

import { Icon } from './Icon';
import SelectInput from './SelectInput';
import { TextBodySmall, TextTag } from './StyledText';
import { TransparentView, Text, Divider } from './Themed';
import Colors from '../constants/Colors';
import useColorScheme from '../hooks/useColorScheme';
import BookingCalendar from '../native/components/BookingCalendar';

type DateRange = {
  startDate: string;
  endDate: string;
};

const blocks = ['5 day 7-10', '5 day 10-12', '12 day 12-17'];

const dateRangesPerBlock = {
  '5 day 7-10': [
    {
      startDate: '2025-06-16',
      endDate: '2025-06-20',
    },
    // July 14 – 18, 2025 Filling up fast!
    {
      startDate: '2025-06-23',
      endDate: '2025-06-27',
    },
    {
      startDate: '2025-07-14',
      endDate: '2025-07-18',
    },
    {
      startDate: '2025-08-04',
      endDate: '2025-08-08',
    },
  ],
  '5 day 10-12': [
    {
      startDate: '2025-06-30',
      days: 5,
      endDate: '2025-07-04',
    },
    // July 14 – 18, 2025 Filling up fast!
    {
      startDate: '2025-07-14',
      days: 5,
      endDate: '2025-07-18',
    },
    {
      startDate: '2025-07-21',
      days: 5,
      endDate: '2025-07-25',
    },
    {
      startDate: '2025-07-28',
      days: 5,
      endDate: '2025-08-01',
    },
  ],
  '12 day 12-17': [
    {
      startDate: '2025-07-07',
      endDate: '2025-07-18',
    },
    {
      startDate: '2025-07-21',
      endDate: '2025-08-01',
    },
  ],
};

export default function CampCalendarContainer() {
  const [scenario, setScenario] = useState<string>('scenario1');
  return (
    <>
      <TextBodySmall
        onPress={() => setScenario('scenario1')}
        bold={scenario === 'scenario1'}
      >
        Scenario 1
      </TextBodySmall>
      <TextBodySmall
        onPress={() => setScenario('scenario2')}
        bold={scenario === 'scenario2'}
      >
        Scenario 2
      </TextBodySmall>
      <Divider style={{ marginVertical: 10 }} />
      {scenario === 'scenario1' ? (
        <CampCalendarContainerS1 />
      ) : (
        <CampCalendarContainerS2 />
      )}
    </>
  );
}
function CampCalendarContainerS1() {
  const [dateRanges, setDateRanges] = useState<DateRange[]>([]);

  const [currentBlock, setCurrentBlock] = useState<string>(blocks[0]!);

  useEffect(() => {
    setDateRanges(
      dateRangesPerBlock[currentBlock as keyof typeof dateRangesPerBlock] ?? []
    );
  }, [currentBlock]);

  console.log(dateRanges, currentBlock);

  return (
    <>
      <SelectInput
        value={currentBlock}
        options={blocks}
        onChange={(option) => setCurrentBlock(option)}
      />
      <CampContent dateRanges={dateRanges} />
    </>
  );
}

function CampCalendarContainerS2() {
  const [dateRanges] = useState<DateRange[]>([
    {
      startDate: '2025-06-17',
      endDate: '2025-07-29',
    },
  ]);
  return (
    <>
      <CampContent dateRanges={dateRanges} daysAllowed={[2]} />
    </>
  );
}

function CampContent({
  dateRanges,
  daysAllowed = [],
}: {
  dateRanges: DateRange[];
  daysAllowed?: number[];
}) {
  const theme = useColorScheme();

  const [configVisible, setConfigVisible] = useState(false);
  const [currentStartDate, setCurrentStartDate] = useState('');
  const [currentDays, setCurrentDays] = useState('');

  const findDateRange = (date: string) => {
    return dateRanges.find(
      (range) => date >= range.startDate && date <= range.endDate
    );
  };

  const handleAddDateRange = () => {
    if (!currentStartDate || !currentDays) return;

    const days = parseInt(currentDays, 10);
    if (isNaN(days) || days <= 0) return;

    // setDateRanges([
    //   ...dateRanges,
    //   {
    //     startDate: currentStartDate,
    //     days,
    //     endDate: addDays(currentStartDate, days - 1),
    //   },
    // ]);
    setCurrentStartDate('');
    setCurrentDays('');
  };

  const handleRemoveDateRange = (index: number) => {
    // setDateRanges(dateRanges.filter((_, i) => i !== index));
  };

  const getDayCellStyle = (day: string) => {
    for (const range of dateRanges) {
      if (day === range.startDate) {
        return { rangeStart: true };
      }
      if (day === range.endDate) {
        return { rangeEnd: true };
      }
    }
    return {};
  };

  const getDayStyle = (day: string) => {
    for (const range of dateRanges) {
      const dayOfWeek = new Date(day).getDay();
      if (day >= range.startDate && day < range.endDate) {
        if (daysAllowed.length > 0 && !daysAllowed.includes(dayOfWeek)) {
          return { backgroundColor: '#eee', opacity: 0.5 };
        }
        // if (dayOfWeek === 0 || dayOfWeek === 6) {
        //   return { backgroundColor: '#eee', opacity: 0.5 }; // Gray for weekends
        // }
        return { backgroundColor: Colors[theme].backgroundSecondary };
      }
    }
    return {};
  };

  return (
    <>
      {dateRanges[0] ? (
        <BookingCalendar
          displayMode="daily"
          onSelect={(day) =>
            configVisible
              ? setCurrentStartDate(day)
              : alert(
                  JSON.stringify(findDateRange(day), null, 2) ??
                    'No date range found'
                )
          }
          getDayCellStyle={getDayCellStyle}
          getDayStyle={getDayStyle}
          initialDate={new Date(dateRanges[0]?.startDate ?? new Date())}
        />
      ) : null}
      <Pressable
        onPress={() => setConfigVisible(!configVisible)}
        style={[
          { backgroundColor: '#eee', alignSelf: 'flex-end', padding: 5 },
          configVisible
            ? { marginBottom: 10 }
            : {
                // position: 'absolute',
                // bottom: 0,
                // right: 0,
                // margin: 10,
                // zIndex: 1000,
              },
        ]}
      >
        <TextTag>{configVisible ? 'Hide Config' : 'Show Config'}</TextTag>
      </Pressable>
      {configVisible ? (
        <TransparentView style={styles.formContainer}>
          <TransparentView style={styles.inputRow}>
            <TransparentView style={styles.dateInput}>
              <Text style={styles.label}>Start Date</Text>
              <TextInput
                value={currentStartDate}
                onChangeText={setCurrentStartDate}
                placeholder="YYYY-MM-DD"
                style={styles.input}
                editable={false}
              />
            </TransparentView>
            <TransparentView style={styles.daysInput}>
              <Text style={styles.label}>Days</Text>
              <TextInput
                value={currentDays}
                onChangeText={setCurrentDays}
                keyboardType="numeric"
                placeholder="Number of days"
                style={styles.input}
              />
            </TransparentView>
            <Pressable
              style={[
                styles.addButton,
                !currentStartDate || !currentDays
                  ? styles.addButtonDisabled
                  : null,
              ]}
              onPress={handleAddDateRange}
              disabled={!currentStartDate || !currentDays}
            >
              <Icon name="plus" style={styles.addIcon} />
            </Pressable>
          </TransparentView>

          {dateRanges.map((range, index) => (
            <TransparentView key={index} style={styles.dateRangeItem}>
              <Text style={styles.dateRangeText}>
                {range.startDate} - {range.endDate}
              </Text>
              <Pressable onPress={() => handleRemoveDateRange(index)}>
                <Icon name="close" style={styles.removeIcon} />
              </Pressable>
            </TransparentView>
          ))}
        </TransparentView>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  formContainer: {
    padding: 16,
    gap: 12,
  },
  inputRow: {
    flexDirection: 'row',
    gap: 10,
    alignItems: 'flex-end',
  },
  dateInput: {
    flex: 1,
  },
  daysInput: {
    flex: 0,
    minWidth: 100,
  },
  label: {
    marginBottom: 4,
    fontSize: 12,
    opacity: 0.7,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 4,
    padding: 8,
    fontSize: 14,
  },
  addButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#007AFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
  },
  addButtonDisabled: {
    opacity: 0.5,
  },
  addIcon: {
    width: 20,
    height: 20,
    tintColor: 'white',
  },
  dateRangeItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 8,
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
  },
  dateRangeText: {
    fontSize: 14,
  },
  removeIcon: {
    width: 16,
    height: 16,
    opacity: 0.5,
  },
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function addDays(dateString: string, days: number): string {
  const date = new Date(dateString);
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0]!;
}
